var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "new-loading" }, [
    !_vm.loading
      ? _c("div", [
          _c(
            "nav",
            {
              staticClass:
                "navbar navbar-expand-lg navbar-dark frontend-header container-fluid"
            },
            [
              _c(
                "nuxt-link",
                {
                  staticClass: "navbar-brand",
                  attrs: { to: { name: "lang", params: { lang: _vm.lang } } }
                },
                [
                  _c("img", {
                    staticStyle: { width: "110px" },
                    attrs: { src: _vm.websiteLogo }
                  })
                ]
              )
            ],
            1
          ),
          _c("div", { staticClass: "container" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.increasing_pct) + "\n            "
            ),
            _c(
              "div",
              { staticClass: "main-progress" },
              [
                _c("progress-bar", {
                  attrs: {
                    size: "tiny",
                    val: _vm.increasing_pct,
                    text: _vm.increasing_pct + "%"
                  }
                }),
                _vm._m(0)
              ],
              1
            ),
            _c("div", [
              _c(
                "div",
                { staticClass: "step-wrapper" },
                [
                  _vm.loadingStep ? _c("loading-svg") : _vm._e(),
                  _c("div", { staticClass: "step1" })
                ],
                1
              )
            ])
          ])
        ])
      : _c(
          "div",
          [
            _c("loading-data", {
              attrs: { searchText: _vm.searchText, type: _vm.type },
              on: { loading: _vm.stopLoading }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", { staticClass: "active", attrs: { id: "step1" } }, [
        _c("h4", [_vm._v("Who's Accessing")])
      ]),
      _c("li", { attrs: { id: "step2" } }, [
        _c("h4", [_vm._v("What's Exposed")])
      ]),
      _c("li", { attrs: { id: "step3" } }, [
        _c("h4", [_vm._v("Where It's Exposed")])
      ]),
      _c("li", { attrs: { id: "step4" } }, [_c("h4", [_vm._v("Your Report")])])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0997a024", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0997a024","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/new-loading.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0997a024","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/new-loading.vue
// module chunks = 7